import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlinePage, JobStatus, AvatarCustom } from 'components/common';
import { useStyle } from '../styles';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import {
  Paper,
  Box,
  Typography,
  Grid,
  IconButton,
  Divider
} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import { ROUTES } from 'consts';


const JobRunTemplateDumb = ({ data, handleDownloadFile, fetchGetNextPage, haveToScrollToEnd, setScrollToEnd }) => {
  const scrollRef = useRef(null);
  const classes = useStyle();
  const theme = useTheme();
  const [t] = useTranslation();
  const [loading, setLoading] = useState(false);

  const details = [
    { primary: 'jobRunTemplate.components.label.project', secondary: data.proj_name },
    { primary: 'jobRunTemplate.components.label.playbok', secondary: data.playbook_id },
    { primary: 'jobRunTemplate.components.label.environment', secondary: data.ansible_runer_path },
    { primary: 'jobRunTemplate.components.label.credential', secondary: data.cred_name },
  ];

  const dates = [
    { label: 'jobRunTemplate.components.label.created', date: data.created },
    { label: 'jobRunTemplate.components.label.start', date: data.start },
    { label: 'jobRunTemplate.components.label.finish', date: data.finish }
  ];

  const DateLabel = ({label, date}) => {
    const dateFormatted = date ? moment(date).subtract(3, 'hours').format('lll') : "-";

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <Typography variant="body1">
          {t(label)}
        </Typography>
        <Typography variant="h6">
          {dateFormatted}
        </Typography>
      </Box>
    );
  }
  const onScrollOut = event =>{
    const objDiv = event.target;
    window.jobheight = document.getElementById("jobout").offsetHeight;
    
    if(objDiv.scrollTop === 0 && fetchGetNextPage){
      setLoading(true);
      fetchGetNextPage();
    }
  }


  const onScrollOutRu = event =>{
    const objDiv = event.target;
    if(objDiv.scrollTop === 0){
      setScrollToEnd(false);
    }
  }

  const scrollToEnd = () => {
    console.log("scroll to end", scrollRef)
    if (scrollRef?.current){
      const objDiv  = scrollRef.current;
      if(haveToScrollToEnd){
        objDiv.scrollTop = objDiv.scrollHeight
      }
      if (data.status != 'RU'){
        objDiv.onscroll = onScrollOut;
      } else {
        objDiv.onscroll = onScrollOutRu;
      }
    }
  }

  const scrollToLittle = () => {
    console.log("scroll to little", scrollRef)
    setLoading(false);
    if (scrollRef?.current){
      const diff = document.getElementById("jobout").offsetHeight-window.jobheight;
      
      const objDiv  = scrollRef.current;
      if (diff>1){
        objDiv.scrollTop = diff;
      }

      objDiv.onscroll = onScrollOut;
    }
  }

  setTimeout(()=>{
    if (!data?.dontHaveToScroll){
      scrollToEnd();
    }else{
      scrollToLittle();
    }
  },500);
  return (
    <>
      <HeadlinePage
        title="jobRunTemplate.headline"
        goBack={ROUTES.JOB_LIST}
      />

      <Paper className={classes.paperStyle}>
        <Box sx={{ width: '100%', display: 'flex', gap: 2, flexDirection: 'row' }}>
          <Typography variant="h6" sx={{ padding: '8px 0px' }}>
            {t('jobRunTemplate.components.title', { job: data.name })}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'center' }}>
            <JobStatus status={data.status} size={'large'}/>
          </Box>
        </Box>

        <Grid container spacing={2}>
          {details.map((d, index) => (
            <Grid item key={index} xs={12} sm={12} md={6} lg={6}>
              <AvatarCustom
                primary={d.primary}
                secondary={d.secondary}
                sx={{ p: 0 }}
              />
            </Grid>
          ))}

          <Grid item xs={12} sm={12} md={12} lg={12}> <Divider sx={{mb: 2}} /></Grid>

          {dates.map((d, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} lg={4}>
              <DateLabel label={d.label} date={d.date}/>
            </Grid>
          ))}

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box
              sx={{
                display: 'flex',
                gap: 0.5,
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  alignItems: 'center',
                  mb: 1,
                  mt: 1
                }}
              >
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  border: `1px solid ${theme.palette.grey[400]}`,
                  borderRadius: 0.5,
                  width: '100%',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: theme.palette.grey[100],
                    width: '100%',
                    borderRadius: '12px 12px 0px 0px',
                    borderBottom: `1px solid ${theme.palette.grey[400]}`,
                    marginBottom: '8px',
                    padding: '8px 16px',
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ fontFamily: 'monospace' }}
                  >
                    {t('jobRunTemplate.components.label.logs')}
                  </Typography>

                  
                  
                  <IconButton onClick={() => handleDownloadFile(data.job_id)} size="small" sx={{ p: 0 }}>
                    <FileDownloadOutlinedIcon size="small" color="primary" />
                  </IconButton>

                </Box>
                {loading?<div class="progress-bar">
                  <div class="progress-bar-value"></div>
                </div>:null}
                <Box sx={{ p: 2, height: '500px', overflowY: 'scroll', width: '100%' }} ref={scrollRef} >
                  <div id='jobout' style={{ fontFamily: 'monospace', fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: data.tail }}></div>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default JobRunTemplateDumb;
